var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoresults = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561,
    height: 500,
    viewBox: "0 0 561 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 561,
    height: 500
  }, /*#__PURE__*/React.createElement("rect", {
    width: 561,
    height: 500,
    fill: "#9F0202"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 206.903,
    cy: 466.717,
    rx: 156.436,
    ry: 156.813,
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 246.012,
    cy: 373.111,
    rx: 31.1275,
    ry: 31.2026,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M286.184 293.452V305.272",
    stroke: "#FEC92E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.319 295.029L294.045 304.332",
    stroke: "#FEC92E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.229 309.84L296.567 311.586",
    stroke: "#FEC92E",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.1144,
    ry: 26.6191,
    transform: "matrix(-0.959157 0.282873 -0.281621 -0.959526 240.473 380.686)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.4033,
    height: 58.4084,
    rx: 10,
    transform: "matrix(-0.995668 0.0929837 0.0925407 0.995709 218.167 311.608)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.1117,
    ry: 26.6242,
    transform: "matrix(0.999989 -0.00468156 0.00465906 0.999989 242.711 401.624)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.6025,
    ry: 26.5573,
    transform: "matrix(-0.184961 0.982746 -0.982583 -0.185824 255.285 329.876)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.5882,
    ry: 16.7382,
    transform: "matrix(-0.770993 -0.636843 0.635019 -0.772497 278.111 325.876)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 29.5119,
    ry: 41.4655,
    transform: "matrix(0.990868 0.134836 -0.134199 0.990954 229.593 344.927)",
    fill: "#359FF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.112,
    ry: 26.6237,
    transform: "matrix(-0.996029 0.0890345 -0.08861 -0.996066 219.191 387.438)",
    fill: "#359FF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 14.112,
    ry: 26.6236,
    transform: "matrix(0.995759 0.0920004 -0.091562 0.995799 219.973 406.964)",
    fill: "#359FF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 11.7532,
    ry: 31.67,
    transform: "matrix(-0.872597 -0.488441 0.486651 -0.873596 197.02 347.185)",
    fill: "#359FF4"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.1631,
    ry: 33.1698,
    transform: "matrix(-0.736113 0.676859 0.676859 0.736113 232.995 296.717)",
    fill: "#359FF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.383 296.44C222.952 310.287 233.961 320.404 245.971 319.036C257.982 317.669 266.447 305.335 264.878 291.488C263.309 277.641 253.49 278.028 241.48 279.395C229.469 280.762 219.814 282.593 221.383 296.44Z",
    fill: "#18191B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.99494,
    ry: 7.82282,
    transform: "matrix(-0.992029 0.126009 0.125413 0.992105 234.263 293.017)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.3575,
    ry: 6.8245,
    transform: "matrix(-0.992029 0.126009 0.125413 0.992105 255.028 289.92)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.0816,
    height: 18.6054,
    rx: 7.54082,
    transform: "matrix(0.959866 -0.279616 0.278507 0.960679 196.595 289.046)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75187,
    height: 10.7967,
    rx: 4.37593,
    transform: "matrix(0.959866 -0.279616 0.278507 0.960679 189.871 252.841)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.92933,
    height: 40.5792,
    rx: 1.46466,
    transform: "matrix(0.959866 -0.279616 0.278507 0.960679 195.455 261.148)",
    fill: "#0881E2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.104,
    height: 23.3459,
    rx: 2,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 407.273 129.229)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1511,
    height: 1.4149,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 411.245 129.673)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3209,
    height: 1.4149,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 413.817 132.099)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1511,
    height: 1.4149,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 416.392 134.525)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.78312,
    height: 1.4149,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 418.965 136.95)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3209,
    height: 1.4149,
    transform: "matrix(0.684037 -0.729447 0.7278 0.685789 421.542 139.377)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1026,
    height: 23.3476,
    rx: 2,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 505.32 148.905)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1501,
    height: 1.41501,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 504.756 152.871)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3201,
    height: 1.41501,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 502.257 155.376)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1501,
    height: 1.41501,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 499.759 157.882)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.78254,
    height: 1.41501,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 497.26 160.385)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3201,
    height: 1.41501,
    transform: "matrix(0.706255 0.707958 -0.706255 0.707958 494.763 162.89)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter4_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.104,
    height: 23.3459,
    rx: 2,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 371.023 217.604)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1511,
    height: 1.4149,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 374.994 217.161)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3209,
    height: 1.4149,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 377.568 214.735)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1511,
    height: 1.4149,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 380.145 212.309)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.78312,
    height: 1.4149,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 382.719 209.884)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3209,
    height: 1.4149,
    transform: "matrix(0.684037 0.729447 0.7278 -0.685789 385.292 207.457)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter5_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.1026,
    height: 23.3476,
    rx: 2,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 478.133 262.53)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1501,
    height: 1.41501,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 477.568 258.563)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3201,
    height: 1.41501,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 475.07 256.061)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 14.1501,
    height: 1.41501,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 472.57 253.555)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7.78254,
    height: 1.41501,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 470.074 251.05)",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11.3201,
    height: 1.41501,
    transform: "matrix(0.706255 -0.707958 -0.706255 -0.707958 467.575 248.546)",
    fill: "#C4C4C4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.553 136.672C447.022 134.592 449.986 134.592 450.455 136.672L456.689 164.337C456.993 165.686 458.542 166.327 459.71 165.587L483.635 150.442C485.436 149.302 487.533 151.395 486.397 153.198L471.277 177.2C470.542 178.367 471.182 179.912 472.528 180.216L500.153 186.471C502.23 186.942 502.23 189.902 500.153 190.373L472.528 196.628C471.182 196.932 470.542 198.477 471.277 199.644L486.397 223.646C487.533 225.449 485.436 227.542 483.635 226.402L459.71 211.257C458.542 210.517 456.993 211.158 456.689 212.507L450.455 240.172C449.986 242.252 447.022 242.252 446.553 240.172L440.319 212.507C440.015 211.158 438.467 210.517 437.298 211.257L413.373 226.402C411.572 227.542 409.475 225.449 410.611 223.646L425.731 199.644C426.467 198.477 425.826 196.932 424.48 196.628L396.856 190.373C394.778 189.902 394.778 186.942 396.856 186.471L424.48 180.216C425.826 179.912 426.467 178.367 425.731 177.2L410.611 153.198C409.475 151.395 411.572 149.302 413.373 150.442L437.298 165.587C438.467 166.327 440.015 165.686 440.319 164.337L446.553 136.672Z",
    fill: "#FEC92E"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 203.683C421.109 202.964 421.823 202.502 422.611 202.502H475.175C476.026 202.502 476.783 203.04 477.064 203.843L478.839 208.927C479.293 210.227 478.328 211.586 476.951 211.586H420.329C418.878 211.586 417.91 210.09 418.504 208.767L420.787 203.683Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 201.866C421.109 201.148 421.823 200.686 422.611 200.686H475.175C476.026 200.686 476.783 201.223 477.064 202.026L478.839 207.11C479.293 208.41 478.328 209.77 476.951 209.77H420.329C418.878 209.77 417.91 208.274 418.504 206.95L420.787 201.866Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 200.051C421.109 199.332 421.823 198.87 422.611 198.87H475.175C476.026 198.87 476.783 199.408 477.064 200.211L478.839 205.295C479.293 206.595 478.328 207.954 476.951 207.954H420.329C418.878 207.954 417.91 206.458 418.504 205.135L420.787 200.051Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 198.234C421.109 197.515 421.823 197.053 422.611 197.053H475.175C476.026 197.053 476.783 197.591 477.064 198.393L478.839 203.477C479.293 204.778 478.328 206.137 476.951 206.137H420.329C418.878 206.137 417.91 204.641 418.504 203.318L420.787 198.234Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 196.417C421.109 195.699 421.823 195.236 422.611 195.236H475.175C476.026 195.236 476.783 195.774 477.064 196.577L478.839 201.661C479.293 202.961 478.328 204.32 476.951 204.32H420.329C418.878 204.32 417.91 202.825 418.504 201.501L420.787 196.417Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 194.6C421.109 193.881 421.823 193.419 422.611 193.419H475.175C476.026 193.419 476.783 193.957 477.064 194.76L478.839 199.844C479.293 201.144 478.328 202.503 476.951 202.503H420.329C418.878 202.503 417.91 201.007 418.504 199.684L420.787 194.6Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 192.783C421.109 192.065 421.823 191.603 422.611 191.603H475.175C476.026 191.603 476.783 192.14 477.064 192.943L478.839 198.027C479.293 199.327 478.328 200.687 476.951 200.687H420.329C418.878 200.687 417.91 199.191 418.504 197.867L420.787 192.783Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 190.966C421.109 190.247 421.823 189.785 422.611 189.785H475.175C476.026 189.785 476.783 190.323 477.064 191.126L478.839 196.21C479.293 197.51 478.328 198.869 476.951 198.869H420.329C418.878 198.869 417.91 197.373 418.504 196.05L420.787 190.966Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter14_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 189.15C421.109 188.431 421.823 187.969 422.611 187.969H475.175C476.026 187.969 476.783 188.507 477.064 189.309L478.839 194.393C479.293 195.694 478.328 197.053 476.951 197.053H420.329C418.878 197.053 417.91 195.557 418.504 194.234L420.787 189.15Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter15_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 187.332C421.109 186.614 421.823 186.151 422.611 186.151H475.175C476.026 186.151 476.783 186.689 477.064 187.492L478.839 192.576C479.293 193.876 478.328 195.235 476.951 195.235H420.329C418.878 195.235 417.91 193.74 418.504 192.416L420.787 187.332Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter16_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 185.515C421.109 184.796 421.823 184.334 422.611 184.334H475.175C476.026 184.334 476.783 184.872 477.064 185.675L478.839 190.759C479.293 192.059 478.328 193.418 476.951 193.418H420.329C418.878 193.418 417.91 191.922 418.504 190.599L420.787 185.515Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter17_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 183.7C421.109 182.982 421.823 182.52 422.611 182.52H475.175C476.026 182.52 476.783 183.057 477.064 183.86L478.839 188.944C479.293 190.244 478.328 191.603 476.951 191.603H420.329C418.878 191.603 417.91 190.108 418.504 188.784L420.787 183.7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter18_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 181.882C421.109 181.163 421.823 180.701 422.611 180.701H475.175C476.026 180.701 476.783 181.239 477.064 182.042L478.839 187.126C479.293 188.426 478.328 189.785 476.951 189.785H420.329C418.878 189.785 417.91 188.289 418.504 186.966L420.787 181.882Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter19_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 180.067C421.109 179.348 421.823 178.886 422.611 178.886H475.175C476.026 178.886 476.783 179.424 477.064 180.226L478.839 185.31C479.293 186.611 478.328 187.97 476.951 187.97H420.329C418.878 187.97 417.91 186.474 418.504 185.151L420.787 180.067Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter20_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 178.248C421.109 177.53 421.823 177.067 422.611 177.067H475.175C476.026 177.067 476.783 177.605 477.064 178.408L478.839 183.492C479.293 184.792 478.328 186.151 476.951 186.151H420.329C418.878 186.151 417.91 184.656 418.504 183.332L420.787 178.248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter21_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 176.433C421.109 175.714 421.823 175.252 422.611 175.252H475.175C476.026 175.252 476.783 175.79 477.064 176.593L478.839 181.677C479.293 182.977 478.328 184.336 476.951 184.336H420.329C418.878 184.336 417.91 182.84 418.504 181.517L420.787 176.433Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter22_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 174.615C421.109 173.896 421.823 173.434 422.611 173.434H475.175C476.026 173.434 476.783 173.971 477.064 174.774L478.839 179.858C479.293 181.158 478.328 182.518 476.951 182.518H420.329C418.878 182.518 417.91 181.022 418.504 179.698L420.787 174.615Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter23_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 172.798C421.109 172.08 421.823 171.617 422.611 171.617H475.175C476.026 171.617 476.783 172.155 477.064 172.958L478.839 178.042C479.293 179.342 478.328 180.701 476.951 180.701H420.329C418.878 180.701 417.91 179.205 418.504 177.882L420.787 172.798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter24_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 170.981C421.109 170.262 421.823 169.8 422.611 169.8H475.175C476.026 169.8 476.783 170.338 477.064 171.141L478.839 176.224C479.293 177.525 478.328 178.884 476.951 178.884H420.329C418.878 178.884 417.91 177.388 418.504 176.065L420.787 170.981Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter25_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.787 169.164C421.109 168.446 421.823 167.983 422.611 167.983H475.175C476.026 167.983 476.783 168.521 477.064 169.324L478.839 174.408C479.293 175.708 478.328 177.067 476.951 177.067H420.329C418.878 177.067 417.91 175.572 418.504 174.248L420.787 169.164Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 50.4668,
    y: 299.904,
    width: 312.872,
    height: 323.626,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.560784 0 0 0 0 0.545098 0 0 0 0 0.560784 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f",
    x: 184.884,
    y: 311.908,
    width: 122.255,
    height: 122.405,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 403.099,
    y: 113.122,
    width: 38.4069,
    height: 38.2896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d",
    x: 484.658,
    y: 146.734,
    width: 38.3258,
    height: 38.3941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d",
    x: 366.85,
    y: 199.422,
    width: 38.4069,
    height: 38.2896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d",
    x: 457.471,
    y: 230.307,
    width: 38.3258,
    height: 38.3941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d",
    x: 413.327,
    y: 199.502,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d",
    x: 413.327,
    y: 197.686,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d",
    x: 413.327,
    y: 195.87,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d",
    x: 413.327,
    y: 194.053,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_d",
    x: 413.327,
    y: 192.236,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_d",
    x: 413.327,
    y: 190.419,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d",
    x: 413.327,
    y: 188.603,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_d",
    x: 413.327,
    y: 186.785,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_d",
    x: 413.327,
    y: 184.969,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_d",
    x: 413.327,
    y: 183.151,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_d",
    x: 413.327,
    y: 181.334,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_d",
    x: 413.327,
    y: 179.52,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_d",
    x: 413.327,
    y: 177.701,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_d",
    x: 413.327,
    y: 175.886,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_d",
    x: 413.327,
    y: 174.067,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_d",
    x: 413.327,
    y: 172.252,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter22_d",
    x: 413.327,
    y: 170.434,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter23_d",
    x: 413.327,
    y: 168.617,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter24_d",
    x: 413.327,
    y: 166.8,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter25_d",
    x: 413.327,
    y: 164.983,
    width: 70.6256,
    height: 19.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoresults);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/noresults.702d501750f266af2e1fb83d87b61ce9.svg";